module.exports = __webpack_public_path__ + "static/full-f607f95344763a88828691fae0b38d4c.png";